import React, {useState, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import {css} from "@emotion/react";
import {breakpoints} from "~styles/global";
import Button from "~components/blocks/Button";
import {Darr} from "~components/Svg";
import {SlideDown} from "react-slidedown";
import "react-slidedown/lib/slidedown.css";

const Select = ({className, options, id, name, placeholder, onChange, background}) => {
  const [optionsVisible, setOptionsVisible] = useState(false);
  const [value, setValue] = useState(false);
  const {mobile, tablet} = breakpoints;

  const buttonStyles = `
    padding: 10px 1em 10px 0;
    border-bottom: 1px solid var(--black);
    display: block;
    width: 100%;
    text-align: left;
    position: relative;

    ${tablet} {
      font-size: 12px;
    }
    svg{
      width: 10px;
      display: inline-block;
      position: absolute;
      top: 50%;
      transition: transform 0.5s;
      transform: translateY(-50%) ${optionsVisible ? "rotate(180deg)" : ""};
      right: 0;
    }
  `;

  useEffect(() => {
    if (!placeholder) {
      setValue(options[0]);
    }
  }, []);

  useEffect(() => {
    nativeSelectRef.current.value = value?.value;
    setOptionsVisible(false);
    if (onChange) {
      onChange(value);
    }
  }, [value]);

  const nativeSelectRef = useRef();

  const handleTriggerClick = (e) => {
    e.preventDefault();
    setOptionsVisible(!optionsVisible);
  };

  const handleOptionClick = (e, option) => {
    e.preventDefault();
    setValue(option);
  };

  const handleBlur = () => {
    setOptionsVisible(false);
  };

  return (
    <div
      className={className}
      css={css`
        margin-bottom: 25px;
        position: relative;
        ${tablet} {
          margin-bottom: 20px;
        }
        select {
          display: none;
        }
      `}
    >
      <button
        onClick={(e) => handleTriggerClick(e)}
        className="h5"
        css={css`
          ${buttonStyles}
        `}
        onBlur={() => handleBlur()}
      >
        {value?.label ?? placeholder}
        <Darr />
      </button>
      <div
        css={css`
          position: absolute;
          background: ${background ?? "var(--white)"};
          left: 0;
          right: 0;
          z-index: 99;
          &:before {
            content: "";
            background: ${background ?? "var(--white)"};
            position: absolute;
            display: block;
            left: -10px;
            right: -10px;
            bottom: -10px;
            top: 0px;
            pointer-events: ${optionsVisible ? "all" : "none"};
            opacity: ${optionsVisible ? "1" : "0"};
            transition: opacity 0.001s;
            transition-delay: ${optionsVisible ? "0" : "0.5s"};
          }
        `}
      >
        <SlideDown
          css={css`
            z-index: 5;
            max-height: 220px;
            overflow: scroll;
          `}
        >
          {optionsVisible ? (
            <div>
              {options.map((option) => (
                <button
                  className="h5"
                  key={option.value + "-button"}
                  value={option.value}
                  onClick={(e) => handleOptionClick(e, option)}
                  css={css`
                    ${buttonStyles}
                    margin-bottom: 0;
                    padding: 1.2em 0;
                    border-bottom-color: var(--grey);
                  `}
                >
                  {option.label}
                </button>
              ))}
            </div>
          ) : null}
        </SlideDown>
      </div>
      <select className="select-native" id={name} name={name} ref={nativeSelectRef}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

Select.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  label: PropTypes.string,
};

Select.defaultProps = {
  placeholder: "State",
  options: [
    {value: "vic", label: "Victoria"},
    {value: "nsw", label: "New South Wales"},
    {value: "qld", label: "Queensland"},
  ],
};

export default Select;
